import React from 'react';
import { X, Minus, Plus, Trash2 } from 'lucide-react';
import { useCart } from '../context/CartContext';

export default function CartDrawer() {
  const { items, removeItem, updateQty, subtotal, open, setOpen, clear } = useCart();

  return (
    <>
      {/* Overlay */}
      <div
        onClick={() => setOpen(false)}
        className={`fixed inset-0 bg-brown-deep/50 z-50 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      />
      {/* Drawer */}
      <aside className={`fixed top-0 right-0 bottom-0 w-full max-w-md bg-cream z-50 shadow-2xl transform transition-transform duration-300 ${open ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center justify-between p-5 border-b border-brown/20">
          <h3 className="font-display text-brown text-xl uppercase">Your Bag ({items.length})</h3>
          <button onClick={() => setOpen(false)} className="text-brown hover:text-pink-hot transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5 space-y-5" style={{ maxHeight: 'calc(100vh - 220px)' }}>
          {items.length === 0 && (
            <div className="text-center py-20">
              <p className="font-display text-brown text-2xl uppercase mb-3">Your bag is empty</p>
              <p className="font-body text-brown/70 text-sm">Time to fill it up, Princesa.</p>
            </div>
          )}
          {items.map((i) => (
            <div key={i.key} className="flex gap-4 items-start">
              <div className="w-20 h-24 bg-pink overflow-hidden flex-shrink-0">
                <img src={i.image} alt={i.name} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1">
                <h4 className="font-body text-brown text-sm leading-snug">{i.name}</h4>
                <p className="font-body text-xs text-brown/60 mt-1">Size: {i.size}</p>
                <div className="flex items-center justify-between mt-2">
                  <div className="inline-flex items-center border border-brown/30">
                    <button onClick={() => updateQty(i.key, i.qty - 1)} className="p-1 text-brown hover:text-pink-hot"><Minus className="w-3 h-3" /></button>
                    <span className="px-3 font-body text-sm text-brown">{i.qty}</span>
                    <button onClick={() => updateQty(i.key, i.qty + 1)} className="p-1 text-brown hover:text-pink-hot"><Plus className="w-3 h-3" /></button>
                  </div>
                  <p className="font-display text-brown text-sm">${(i.price * i.qty).toFixed(2)}</p>
                </div>
              </div>
              <button onClick={() => removeItem(i.key)} className="text-brown/50 hover:text-pink-hot">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>

        <div className="absolute bottom-0 left-0 right-0 border-t border-brown/20 p-5 bg-cream-2">
          <div className="flex items-center justify-between mb-4">
            <p className="font-anton uppercase tracking-widest text-xs text-brown/70">Subtotal</p>
            <p className="font-display text-brown text-xl">${subtotal.toFixed(2)}</p>
          </div>
          <button disabled={items.length === 0} onClick={() => { clear(); setOpen(false); }}
            className="w-full btn-primary py-4 font-anton uppercase tracking-widest text-sm disabled:opacity-40 disabled:cursor-not-allowed">
            Checkout — mock
          </button>
          <p className="font-body text-[11px] text-brown/60 mt-3 text-center">Free shipping on orders over $75 (US)</p>
        </div>
      </aside>
    </>
  );
}
